import { IPhongUuTienNhom } from "../../model/respone/category/IPhongUuTienNhom";
import { apiClient } from "../apiClient";

export const PHONG_UU_TIEN_NHOM_API = "phong-uu-tien-nhom";
export const phongUuTienNhomApi = {
  SelectAll: () => apiClient.get(`${PHONG_UU_TIEN_NHOM_API}`),
  Insert: (payload: IPhongUuTienNhom) => apiClient.post(`${PHONG_UU_TIEN_NHOM_API}`, payload),
  Update: (payload: IPhongUuTienNhom) => apiClient.put(`${PHONG_UU_TIEN_NHOM_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${PHONG_UU_TIEN_NHOM_API}/${id}`),
};
